
























import { login } from '@/api/auth'
import { namespace } from 'vuex-class'
import { Component, Vue } from 'vue-property-decorator'

const authModule = namespace('auth')

@Component({
  components: {}
})

export default class extends Vue {
  @authModule.Mutation('login') public login!: Function
  @authModule.Action('pullProfile') public pullProfile!: Function

  loading = false

  rules = {
    email: [
      { required: true, message: '请输入您的邮箱', trigger: 'blur' }
    ],
    // eslint-disable-next-line
    password: [
      { required: true, message: '请输入您的密码', trigger: 'blur' }
    ]
  }

  model = {
    email: null,
    password: null
  }

  async created () {
    // await this.refreshQrCode()

    // this.interval = setInterval(this.verifyState, 3000)
  }

  // validate form
  validateForm (): void {
    const el: any = this.$refs.form
    el.validate((val: boolean) => val && this.sendRequest())
  }

  // send login request
  async sendRequest () {
    const params: Record<string, any> = this.model
    try {
      const { data } = await login(params)
      if (!data.token) {
        return false
      }
      this.login(data.token)
      this.pullProfile()
      this.$eva.success('Login the success!')
      this.$router.push({ name: 'dashboard' })
    } finally {
    }
  }
}
